import moment from 'moment';

// Formats used by BACKEND ONLY, do not use them for display
export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';

// Formats used for display purposes only
export const DISPLAY_TIME_FORMAT = 'LT'; // h:mm a
export const DISPLAY_SHORT_DATE_FORMAT = 'L'; // MMM D
export const DISPLAY_DATE_FORMAT = 'LL'; // MM/DD/YYYY
export const DISPLAY_DATE_FORMAT_WITH_YEAR = 'LLL'; // MMM D, YYYY
export const DISPLAY_DATE_FORMAT_WITH_TIME = 'LLLL'; // MMM D, YYYY LT

export const DISPLAY_DATE_DAY_MONTH = 'll'; // ddd, MMM D
export const DISPLAY_DATE_DAY_YEAR = 'lll'; // ddd, MMM D YYYY
export const DISPLAY_DATE_DAY_YEAR_TIME = 'llll'; // ddd, MMM D YYYY, LT

// singular moment.js formats
export const DISPLAY_DATE = 'D';
export const DISPLAY_DATE_DAY = 'ddd';
export const DISPLAY_DATE_DAY_LONG = 'dddd';
export const DISPLAY_DATE_ORDINAL = 'Do';
export const DISPLAY_DATE_MONTH = 'MMM';
export const DISPLAY_DATE_MONTH_LONG = 'MMMM';
export const DISPLAY_DATE_YEAR = 'YYYY';
export const DISPLAY_DATE_MONTH_YEAR = 'MMM YYYY'; // MMM YYYY

export const formatDate = (date, format = DISPLAY_DATE_FORMAT_WITH_YEAR) => {
    const formattedDate = moment(date).isValid() ? date : new Date(date);

    return moment(formattedDate).format(format);
};
